export default __webpack_public_path__ + "static/media/link2.5ff19b4c.png";